const PlayerBar = ({ playerName, playerColor, capturedPieces, isTop, playerLogo }) => {
  const getPieceValue = (pieceType) => {
    const values = { 'p': 1, 'n': 3, 'b': 3, 'r': 5, 'q': 9 };
    return values[pieceType] || 0;
  };

  const totalValue = capturedPieces.reduce((sum, piece) => sum + getPieceValue(piece), 0);

  const getPieceUnicode = (pieceType) => {
    const pieces = { 'p': '♟', 'n': '♞', 'b': '♝', 'r': '♜', 'q': '♛', 'k': '♚' };
    return pieces[pieceType] || '';
  };

  return (
    <div className={`bg-surface dark:bg-dark-surface border-l-3 border-border-heavy dark:border-dark-border-heavy px-4 py-3 ${isTop ? 'mb-1' : 'mt-1'} border-2 border-border dark:border-dark-border`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 border-2 border-accent dark:border-dark-accent flex items-center justify-center text-xl bg-background dark:bg-dark-background p-1">
            {isTop && playerLogo ? (
              <img src={playerLogo} alt={playerName} className="w-full h-full object-contain" />
            ) : (
              isTop ? '🤖' : '👤'
            )}
          </div>
          <div>
            <div className="text-text-primary dark:text-dark-text-primary font-bold text-base">{playerName}</div>
            {totalValue > 0 && (
              <div className="text-text-secondary dark:text-dark-text-secondary text-sm font-mono font-bold">+{totalValue}</div>
            )}
          </div>
        </div>
        
        {/* Captured pieces */}
        <div className="flex items-center gap-2">
          {capturedPieces.map((piece, index) => (
            <span key={index} className="text-text-secondary dark:text-dark-text-secondary text-xl">
              {getPieceUnicode(piece)}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlayerBar;
